var IconButton    = require("app/ui/IconButton"),
    LoginButton   = require("app/Auth/LoginButton"),
    frameThrottle = require("enyo-perf/utils").frameThrottle,
    icons         = require("app/theme/icons"),
    kind          = require("enyo/kind");

require("./LoginCta.less");
require("app/theme/IconButton--neutral-ghost.less");

module.exports = kind(/** @lends  app.Bookmarks.LoginCta.prototype */ {

    /**
     * @private
     */
    name: "app.Bookmarks.LoginCta",

    /**
     * @private
     */
    classes: "app-bookmarks-login-cta",

    /**
     * @private
     */
    components: [{
        name:    "title",
        tag:     "h1",
        classes: "app-bookmarks-login-cta__title"
    }, {
        name:    "body",
        classes: "app-bookmarks-login-cta__body",
        tag:     "p"
    }, {
        classes:    "app-bookmarks-login-cta__buttons",
        components: [{
            name:    "loginButton",
            kind:    LoginButton,
            classes: "app-bookmarks-login-cta__login-button"
        }, {
            name:    "cancelButton",
            kind:    IconButton,
            classes: "app-bookmarks-login-cta__cancel-button",
            ontap:   "onCancelButtonTap",
            icon:    icons["app.Bookmarks.LoginCta.cancelButton"],
            theme:   "neutral-ghost"
        }]
    }],

    /**
     * @private
     */
    handlers: {
        onCancelButtonTap: "onCancelButtonTap"
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var i18nService = this.app.$.i18nService;

        this.$.title.set("content", i18nService.getString("app.Bookmarks.LoginCta.title"));
        this.$.body.set("content", i18nService.getString("app.Bookmarks.LoginCta.body"));
        this.$.cancelButton.set("caption", i18nService.getString("app.Bookmarks.LoginCta.CancelButton.caption"));
        this.$.cancelButton.set("tooltip", i18nService.getString("app.Bookmarks.LoginCta.CancelButton.tooltip"));
    },

    /**
     * Navigate back to the previous route.
     *
     * @private
     */
    onCancelButtonTap: function() {
        this.bubble("onRequestHide");
    }

});
